import { css } from '@/styled-system/css';

export const skeletonAreaCard = css({
  textAlign: 'center',
  margin: '1x',
  paddingTop: '1x',
  paddingRight: '2x',
  paddingBottom: '1x',
  paddingLeft: '2x',
  width: '100%',

  md: {
    width: '40%',
  },

  lg: {
    width: '30%',
  },

  '&:hover': {
    boxShadow: '0 8px 32px 0 rgba(0, 0, 0, 0.1)',
  },
});

export const skeletonAreaCardContainer = css({
  boxShadow: '0 2px 4px 0 rgba(0, 0, 0, 0.1)',
  borderWidth: '1px',
  borderStyle: 'solid',
  borderColor: 'hpxGrey500',
  backgroundColor: 'hpxWhite',
  color: 'hpxBlue600',
  position: 'relative',
  cursor: 'pointer',
  borderRadius: '4px',
  width: '100%',
  overflow: 'hidden',

  xl: {
    width: '286px',
  },
});

export const skeletonAreaCardContentContainer = css({
  verticalAlign: 'top',
  display: 'inline-block',
  paddingTop: '1x',
  paddingRight: '2x',
  paddingBottom: '1x',
  paddingLeft: '2x',
  width: '100%',
});
